require.config({
    baseUrl: 'js',
    paths: {
        aja: 'lib/aja/src/aja',
        'es6-promise-polyfill': 'lib/es6-promise-polyfill/promise',
        leaflet: 'lib/leaflet/dist/leaflet-src',
        'leaflet-minimap': 'lib/leaflet-minimap/dist/Control.MiniMap.min',
        'leaflet.markercluster': 'lib/leaflet.markercluster/dist/leaflet.markercluster-src',
        'mapbox-gl-js': 'lib/mapbox-gl-js/index',
        'mapbox-gl-leaflet': 'lib/mapbox-gl-leaflet/leaflet-mapbox-gl',
        pancontrol: 'lib/pancontrol/src/L.Control.Pan',
        requirejs: 'lib/requirejs/require',
        t: 'lib/t.js/t',
        zoomslider: 'lib/zoomslider/src/L.Control.Zoomslider'
    },
    shim: {
        'display/map': {
            exports: 'L'
        },
        markercluster: {
            deps: [
                'display/map'
            ]
        }
    },
    map: {
        '*': {
            http: 'requester/requester',
            security: 'security/apiKeySecurity',
            endpoints: 'endpoints/endpoints',
            mapboxProvider: 'mapboxProvider/mapboxProvider'
        }
    },
    packages: [

    ]
});

define("config", function(){});

